import React from "react";
import { Leaf, ShieldCheck, FlaskConical, Lock, Truck, MapPin, BadgeCheck } from "lucide-react";

const items = [
  { icon: Leaf,          label: "100% Ayurvedic" },
  { icon: ShieldCheck,   label: "No Steroids" },
  { icon: FlaskConical,  label: "No Chemicals" },
  { icon: Lock,          label: "Secure Payments" },
  { icon: Truck,         label: "Cash on Delivery" },
  { icon: MapPin,        label: "Made in India" },
];

export default function TrustStrip() {
  return (
    <section className="relative border-y border-white/5 bg-black px-4 py-6 sm:py-8">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-3 gap-2 sm:grid-cols-6 sm:gap-4">
          {items.map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex flex-col items-center gap-2 rounded-2xl border border-white/5 bg-white/[0.03] px-2 py-3 text-center transition-colors hover:border-[#FF7A00]/30 hover:bg-[#FF7A00]/5"
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-fire text-black">
                <Icon size={16} />
              </div>
              <div className="text-[10px] font-semibold uppercase leading-tight tracking-wider text-neutral-200 sm:text-[11px]">
                {label}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-center gap-2 text-center text-[11px] uppercase tracking-widest text-[#FFC107] sm:text-xs">
          <BadgeCheck size={14} />
          Manufactured in an AYUSH-licensed facility
        </div>
      </div>
    </section>
  );
}
